import React from 'react';
import InfoBall from '../InfoBall.js';
import {MinusIcon} from "../icons/MinusIcon";
import {PlusIcon} from "../icons/PlusIcon";

class PercentageInput extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      inputFocused: false,
      stateValue: this.props.state[this.props.field.stateId],
      inputValue: this.props.state[this.props.field.stateId],
    };
  }

  onBlur = (e) => {
    this.setState({inputFocused: false}, () => {
      this.setNewValue(Number(this.state.inputValue), true);
    });
    document.getElementById("percentage-input-"+this.props.parentIndex+"-"+this.props.index).blur();
  }

  onFocus = (e) => {
    this.setState({
      inputFocused: true,
      inputValue: (this.props.state[this.props.field.stateId]).toFixed(this.props.field.decimals)
    }, () => {
      let elem = document.getElementById("percentage-input-"+this.props.parentIndex+"-"+this.props.index);
      elem.focus();
      elem.setSelectionRange(0, 9999);
    });
  }

  handleChange(e) {
    let curVal = e.target.value;
    this.setState({inputValue: curVal}, () => {
      this.setNewValue(curVal, false);
    });
  }

  showDecimalValue(value) {
    if(value === undefined || value === null) return;
    if(!this.state.inputFocused) value = (+value).toFixed(this.props.field.decimals);
    return value.toString().replace(".", ",");
  }

  setNewValue(curVal, happensOnBlur) {
    curVal = curVal.toString().replace(",", ".");
    if(isNaN(curVal)) {
      this.setState({inputValue: this.props.state[this.props.field.stateId]});
      return;
    }
    curVal = Number(Math.round(curVal+'e'+this.props.field.decimals)+'e-'+this.props.field.decimals);
    curVal = (+curVal).toFixed(this.props.field.decimals);
    if(Number(curVal) >= this.props.field.min &&
      Number(curVal) <= this.props.field.max) {
      this.props.updateState({[this.props.field.stateId]: Number(curVal)});
      if(happensOnBlur) this.setState({inputValue: curVal});
    } else
    if(happensOnBlur) {
      if(Number(curVal) < this.props.field.min) {
        this.props.updateState({[this.props.field.stateId]: this.props.field.min});
        this.setState({inputValue: (this.props.field.min).toFixed(this.props.field.decimals)});
      } else
      if(Number(curVal) > this.props.field.max) {
        this.props.updateState({[this.props.field.stateId]: this.props.field.max});
        this.setState({inputValue: (this.props.field.max).toFixed(this.props.field.decimals)});
      }
    }
  }

  increaseValue() {
    this.setNewValue(this.props.state[this.props.field.stateId] + this.props.field.step, true);
  }

  decreaseValue = () => {
    this.setNewValue(this.props.state[this.props.field.stateId] - this.props.field.step, true);
  }

  componentDidUpdate() {
    if(this.props.state[this.props.field.stateId] !== this.state.stateValue) {
      this.setState({stateValue: this.props.state[this.props.field.stateId],
                     inputValue: this.props.state[this.props.field.stateId]});
    }
  }

  render() {
    return <div className="percentage-input input-elem">
      <label htmlFor={"percentage-input-"+this.props.parentIndex+"-"+this.props.index} className="percentage-input__label">
        <div className="percentage-input__label-text">{this.props.field.title}</div>
        <div className="percentage-input__input-wrapper">
          <button
            className="percentage-input__button"
            onClick={() => {this.decreaseValue()}}>
            <MinusIcon marginToTop={4} />
          </button>
          <div className="percentage-input__input-field">
            <input
              className="percentage-input__input"
              type="text"
              id={"percentage-input-"+this.props.parentIndex+"-"+this.props.index}
              onBlur={(e) => {this.onBlur(e)}}
              onFocus={(e) => {this.onFocus(e)}}
              value={this.showDecimalValue(this.state.inputValue)}
              onKeyPress={(e) => {
                e.persist();
                if(e.key === "Enter") { this.onBlur(); } else
                if(e.key === "+") { this.increaseValue(); } else
                if(e.key === "-") { this.decreaseValue(); }
              }}
              onChange={this.handleChange.bind(this)}
              maxLength="5" />
            <span className="percentage-input__unit">{this.props.unit ? this.props.unit : "%"}</span>
          </div>
          <button
            className="percentage-input__button plus"
            onClick={() => {this.increaseValue()}}>
            <PlusIcon marginToTop={4}/>
          </button>
        </div>
      </label>
      {this.props.field.infoText ?
        <InfoBall text={this.props.field.infoText}></InfoBall>
        : null}
    </div>;
  }
}

export default PercentageInput;
